/**
 * @file This component updates the page title when the route changes or
 * the title is updated.
 */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import { emptyVNode } from '@/utils';
export default tsx.component({
    name: 'page-title',
    props: {
        pageTitle: p(String).required,
    },
    computed: {
        /** @returns The current route name. */
        currentRouteName() {
            return this.$route.name;
        },
    },
    methods: {
        /** Sets the page title. */
        setPageTitle() {
            this.$router.setPageTitle(this.pageTitle);
        },
    },
    watch: {
        /** When the prop changes, resets the page title. */
        pageTitle() {
            this.setPageTitle();
        },
        /** When the route changes, resets the page title. */
        currentRouteName() {
            this.setPageTitle();
        },
    },
    /** On the component creation, sets the page title. */
    created() {
        this.setPageTitle();
    },
    /** @returns An empty node. This component has no visual effect in pages. */
    render() {
        return emptyVNode();
    },
});
